import * as swcHelpers from '@swc/helpers';
import React__default from 'react';

// Attempts to lazy load the provided path. If it fails (for example, due to the fact that
// the user doesn't have an internet connection), the function falls back to an empty svg.
const lazyLoadWithFallback = (importer)=>{
    return /*#__PURE__*/ React__default.lazy(swcHelpers.asyncToGenerator(function*() {
        try {
            return yield importer();
        } catch (e) {
            return {
                default: (props)=>/*#__PURE__*/ React__default.createElement("svg", swcHelpers.extends({}, props))
            };
        }
    }));
};

export { lazyLoadWithFallback };
//# sourceMappingURL=lazy-load-with-fallback.js.map
